// اجزای مشترک صفحه‌های اماکن، مسئول مکان، واگذاری/جابجایی، گزارش کلی و درخواست کالا
import React, { useState, useEffect, useRef } from 'react';
import { ui } from '../../components/ListPage';
import { openReport } from '../../components/report';
import { jsonOf, netErr } from '../../utils/http';

export const API = (path, opts = {}) => fetch(`/api/tadarokat/place${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

export const qs = (o) => Object.entries(o || {})
  .filter(([, v]) => v !== undefined && v !== null && v !== '')
  .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');

export const toFa = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
export const toEng = s => String(s ?? '').replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));
export const num = v => { const n = Number(toEng(String(v ?? '')).replace(/,/g, '')); return isNaN(n) ? 0 : n; };
export const fmtAmt = n => (Number(n || 0) ? Number(n).toLocaleString('fa-IR') : '•');
export const fmtCnt = n => (Number(n || 0) ? Number(n).toLocaleString('fa-IR') : '•');
export const splitLines = m => String(m || '').split('\n');

export const curYear = () => {
  const y = new Date().toLocaleDateString('fa-IR-u-nu-latn').split('/')[0];
  return parseInt(y, 10) || 1405;
};

export const DEL_ASK = 'آيا از حذف اين رکورد مطمئن هستيد؟';

export const smallBtn = { ...ui.btnItems, padding: '7px 12px', fontSize: '12px', cursor: 'pointer' };

/** پوستهٔ تمام‌صفحه برای فرم‌های فرعی */
export function SubFormShell({ children }) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 900, background: '#f0f2f7', overflow: 'hidden' }}>
      {children}
    </div>
  );
}

/** پیام ساده با یک دکمه */
export function MessageBox({ title = 'پیام', lines = [], onClose }) {
  const okRef = useRef(null);
  useEffect(() => { if (okRef.current) okRef.current.focus(); }, []);
  return (
    <div style={{ ...ui.overlay, zIndex: 3000 }} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: '520px' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>{title}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>
        <div style={{ ...ui.mBody, lineHeight: 2, fontSize: '13px' }}>
          {lines.map((l, i) => <div key={i}>{l || ' '}</div>)}
        </div>
        <div style={ui.mFooter}>
          <button ref={okRef} onClick={onClose} style={ui.btnSave}>تایید</button>
        </div>
      </div>
    </div>
  );
}

/** مودال عمومی */
export function Modal({ title, onClose, children, footer, width = '640px', z = 1000 }) {
  return (
    <div style={{ ...ui.overlay, zIndex: z }} onClick={onClose}>
      <div style={{ ...ui.modal, maxWidth: width, overflow: 'visible' }} onClick={e => e.stopPropagation()}>
        <div style={ui.mHeader}>
          <div style={ui.mTitle}>{title}</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>
        <div style={{ ...ui.mBody, overflow: 'auto' }}>{children}</div>
        {footer && <div style={ui.mFooter}>{footer}</div>}
      </div>
    </div>
  );
}

/** فیلد ساده */
export function Field({ label, value, onChange, flex = 1, disabled, onKeyDown, onBlur, ltr, minWidth = '120px' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, minWidth }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value ?? ''} onChange={e => onChange && onChange(e.target.value)} disabled={disabled}
        onKeyDown={onKeyDown} onBlur={onBlur}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff', direction: ltr ? 'ltr' : 'rtl' }} />
    </div>
  );
}

/** قاب برچسب‌دار برای اجزای دلخواه */
export function Box({ label, children, flex = 1, minWidth = '120px' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, minWidth }}>
      <label style={ui.mlabel}>{label}</label>
      {children}
    </div>
  );
}

/** جستجوی انتخابی — سرور {id, code, title, display} برمی‌گرداند */
export function Lookup({ label, value, endpoint, onPick, flex = 1, disabled, onFree }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}${endpoint.includes('?') ? '&' : '?'}q=${encodeURIComponent(text)}`);
    if (j.ok) {
      setRows(j.rows || j.data || []);
      setOpen(true);
    }
  };
  const leave = () => setTimeout(() => {
    setOpen(false);
    if (!value && q.trim() && onFree) onFree(q.trim(), rows.length);
  }, 200);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative', minWidth: '160px' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} disabled={disabled} placeholder="جستجو..."
        onChange={e => { if (!disabled) { if (value) onPick({ id: 0, title: '', display: '' }); search(e.target.value); } }}
        onBlur={leave}
        style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
      {value && !disabled && (
        <button onClick={() => { onPick({ id: 0, title: '', display: '' }); setQ(''); }}
          style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828' }}>✕</button>
      )}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '260px', overflowY: 'auto' }}>
          {rows.map(r => (
            <div key={r.id} onMouseDown={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#e8f0fe'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}>
              {toFa(r.display || r.title)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const isEmptyV = v => v === '' || v === null || v === undefined || v === 0 || v === '0';

/** ستون‌هایی که در همهٔ ردیف‌ها خالی‌اند نشان داده نمی‌شوند */
export const visibleCols = (cols, rows) => cols.filter(c => c.always || (rows || []).some(r => !isEmptyV(r[c.key])));

/** جدول با انتخاب ردیف؛ ستون‌ها {key, label, num?, money?, wrap?} ؛ checked: Set برای انتخاب چندتایی */
export function Grid({ columns, rows, selectedId, onSelect, onDouble, onContext, empty = 'موردی یافت نشد', loading,
  zebra = '#fdf6ec', checked, onCheck, rowKey = 'id' }) {
  return (
    <>
      <table style={ui.table}>
        <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
          <tr>
            {checked && <th style={{ ...ui.th, width: '30px' }} />}
            {columns.map(c => <th key={c.key} style={ui.th}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((r, i) => {
            const k = r[rowKey] ?? i;
            const sel = selectedId != null && selectedId === k;
            const bg = sel ? '#e8f0fe' : (i % 2 ? zebra : '#fff');
            return (
              <tr key={k} style={{ background: bg, cursor: 'pointer' }}
                onClick={() => onSelect && onSelect(r)} onDoubleClick={() => onDouble && onDouble(r)}
                onContextMenu={e => { if (onContext) { e.preventDefault(); onContext(r); } }}>
                {checked && (
                  <td style={ui.td} onClick={e => e.stopPropagation()}>
                    <input type="checkbox" checked={checked.has(k)} onChange={() => onCheck && onCheck(k)} />
                  </td>
                )}
                {columns.map(c => {
                  const v = r[c.key];
                  let t;
                  if (c.money) t = fmtAmt(v);
                  else if (c.num) t = fmtCnt(v);
                  else t = toFa(v ?? '');
                  return (
                    <td key={c.key} title={String(v ?? '')}
                      style={{ ...(c.money || c.num ? ui.tdNum : ui.td), textAlign: c.money ? 'left' : (c.wrap ? 'right' : 'center'),
                        maxWidth: c.wrap ? '280px' : undefined, overflow: 'hidden', textOverflow: 'ellipsis',
                        whiteSpace: c.pre ? 'pre-line' : ui.td.whiteSpace, fontWeight: sel ? 700 : undefined }}>
                      {t}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {!loading && (rows || []).length === 0 && <div style={ui.empty}>{empty}</div>}
    </>
  );
}

/** اجرای گزارش؛ خطا با onError برمی‌گردد */
export async function runReport(key, params, onError) {
  try {
    await openReport(key, params);
  } catch (e) {
    if (onError) onError(e.message || 'خطا در تهیه گزارش');
  }
}

/** کادر «تغییر موارد استفاده» */
export function ChangeUsesDialog({ info, targetsEndpoint, onMove, onClose, notChosenMsg }) {
  const [target, setTarget] = useState({ id: 0, display: '' });
  const [thisYear, setThisYear] = useState(true);
  const [err, setErr] = useState('');
  const doMove = () => {
    if (!target.id) { setErr(notChosenMsg); return; }
    if ((thisYear && !info.cnt_year) || (!thisYear && !info.cnt)) { setErr('تعداد موارد استفاده صفر است'); return; }
    onMove(target.id, thisYear);
  };
  return (
    <Modal title={info.caption} onClose={onClose} width="560px"
      footer={<>
        <button onClick={onClose} style={ui.btnCancel}>لغو</button>
        <button onClick={doMove} style={ui.btnSave}>انتقال</button>
      </>}>
      {err && <div style={ui.errBox}>⚠️ {err}</div>}
      <div style={ui.row}>
        <label style={{ fontSize: '13px' }}>
          <input type="radio" checked={thisYear} onChange={() => setThisYear(true)} /> {`سال ${toFa(info.year)}`} ({toFa(info.cnt_year)})
        </label>
        <label style={{ fontSize: '13px' }}>
          <input type="radio" checked={!thisYear} onChange={() => setThisYear(false)} /> کلیه اطلاعات ({toFa(info.cnt)})
        </label>
      </div>
      <div style={ui.row}>
        <Lookup label="به" value={target.display} endpoint={targetsEndpoint} onPick={setTarget} />
      </div>
    </Modal>
  );
}

/** ستون‌های فهرست واگذاری‌ها (اماکن و واگذاری/جابجایی) */
export const PP_COLS = [
  { key: 'asker', label: 'درخواست کننده', wrap: true },
  { key: 'goods_receiver', label: 'تحویل گیرنده', wrap: true },
  { key: 'request_no', label: 'درخواست' },
  { key: 'request_date', label: 'تاریخ درخواست' },
  { key: 'permission_no', label: 'شماره مجوز' },
  { key: 'event_date', label: 'تاریخ واگذاری' },
  { key: 'leave_date', label: 'تاریخ جابجایی' },
  { key: 'label_no', label: 'برچسب' },
  { key: 'old_label_no', label: 'برچسب قدیم' },
  { key: 'title', label: 'عنوان', wrap: true },
  { key: 'feature', label: 'ویژگی', wrap: true },
  { key: 'remark', label: 'توضیح', wrap: true },
  { key: 'quantity', label: 'تعداد', num: true },
  { key: 'from_serial', label: 'از سریال' },
  { key: 'to_serial', label: 'تا سریال' },
  { key: 'stock', label: 'انبار', wrap: true },
  { key: 'delivery_time', label: 'زمان تحویل' },
  { key: 'user_group', label: 'گروه کاربری' },
];

/** ستون‌های سابقهٔ کالا */
export const HISTORY_COLS = [
  { key: 'label_no', label: 'برچسب' }, { key: 'slip', label: 'قبض انبار/مجوز واگذاری' }, { key: 'date', label: 'تاریخ' },
  { key: 'price', label: 'قیمت', money: true }, { key: 'ag_kind', label: 'نوع انبارگردانی' },
  { key: 'ag_qty', label: 'تعداد انبارگردانی', num: true }, { key: 'buy_qty', label: 'تعداد خرید', num: true },
  { key: 'from_serial', label: 'از شماره سریال' }, { key: 'to_serial', label: 'تا شماره سریال' },
  { key: 'given_qty', label: 'تعداد واگذارشده', num: true }, { key: 'return_qty', label: 'تعداد مرجوعی', num: true },
  { key: 'stock', label: 'موجودی', num: true, always: true }, { key: 'receiver', label: 'دریافت کننده', wrap: true },
  { key: 'leave_date', label: 'تاریخ خروج' }, { key: 'send_letter_no', label: 'شماره نامه ارسال به خزانه' },
  { key: 'send_letter_date', label: 'تاریخ نامه ارسال به خزانه' }, { key: 'request_no', label: 'شماره درخواست' },
  { key: 'request_date', label: 'تاریخ درخواست' }, { key: 'asker', label: 'درخواست کننده', wrap: true },
  { key: 'asker_dept', label: 'واحد درخواست کننده', wrap: true }, { key: 'seller', label: 'فروشنده', wrap: true },
  { key: 'factor_no', label: 'شماره فاکتور' }, { key: 'factor_date', label: 'تاریخ فاکتور' },
  { key: 'stock_time', label: 'زمان تحویل انبار' }, { key: 'hazineh_no', label: 'شماره سند هزینه' },
  { key: 'hazineh_date', label: 'تاریخ سند هزینه' },
];
